import React, { Children } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { styled } from '../../styles/stitches.config';
import { GatsbyImage, getImage, StaticImage } from 'gatsby-plugin-image';

const ProcessSection = () => {

    const data = useStaticQuery(
        graphql`
          query {
            allFile: file(name: { eq: "versions" }) {
              childImageSharp {
                  gatsbyImageData
              }
            }
          }
        `
    )

    const ProcessSection = styled('section', {
        display: 'grid',
        gridTemplateColumns: '4fr 3fr',
        fontFamily: '$lato',
        gap: '120px',
        justifyContent: 'end',
        paddingBottom: '80px',
        paddingLeft: '20px',
        img: {
            borderRadius: '0 !important',
        },
        '@bp1': {
            gridTemplateColumns: '1fr',
            paddingLeft: '0px',
            gap: '0px',
        },
        '& .processDetails': {
            '@bp1': {
                order: 2,
                padding: '0 20px',
            },
        },
        p: {
            fontFamily: '$lato',
            fontSize: '18px',
            lineHeight: '29px',
            color: '#585d6c',
            maxWidth: '650px',
            margin: '0 0 20px 0',
        },
        '& h3': {
            marginTop: '80px',
            fontSize: '16px',
            marginBottom: '12px',
            fontFamily: '$lato',
            textTransform: 'uppercase',
            letterSpacing: '.1em',
            '@bp1': {
                marginTop: '40px',
            },
        },
        '& h2': {
            fontFamily: '$default',
            fontSize: '48px',
            lineHeight: '1.2',
            marginBottom: '20px',
            '@bp1': {
                fontSize: '48px',
                lineHeight: '1.2',
            },
        },
    });

    const image = getImage(data.allFile);

    return (
        <ProcessSection>
            <div className="processDetails" style={{
                display: 'flex',
                flexFlow: 'column wrap',
                alignContent: 'flex-end',
            }}>
                <h3>Our Process</h3>
                <h2>From Our Skin to Yours</h2>
                <p>To develop a product with true efficacy and to ensure accessibility for different skin conditions, we knew from the very beginning that it was crucial to involve actual skincare users beyond our immediate circles in the entire development process - from conceptualisation to testing, sourcing, designing and finally, to launching.</p>
                <p>Each batch of our lab samples (V.1 through V.5) was tested not only by us at Better Days, but also friends of friends and new connections made via social media. From there, we were able to consider and make adjustments based on everyone’s feedback for each iteration of the lab samples before we released them for further testing.</p>
                <p>We love to share all the things that are usually &quot;behind-the-scenes&quot; because all the discussions we have with everyone provides valuable insight on matters ranging from texture, ingredients and packaging to compatibility and feel-good factors, etc.</p>
                <p>On an intangible level but perhaps most precious, the encouragement we receive from friends new and old alike motivates us deeply and keeps us from operating alone in an echo chamber. We truly enjoy learning from what everyone shares with us - it feels like we are a community connected by a common love for better skin health.</p>
                <p>Our Multi-Active Treatment Essence is a culmination of this 2 year process but at the same time remains open-ended and will evolve as skin science advances. To do this, we aim to release the product in small batches so we can stay flexible for continuous improvement.</p>
            </div>
            <div>
                <div style={{ top: '0', position: 'sticky' }}>
                    <GatsbyImage image={image} alt={'blah'} />
                </div>
            </div>
        </ProcessSection>
    )
}

export default ProcessSection
